import PromptLoopConfig from "./PromptLoopConfig";
import WorkflowLoopConfig from "./WorkflowLoopConfig";
import { LoopConfiguration, LoopType } from "./types";

import { PromptTemplateConfiguration } from "@/types/evaluate";

interface WorkflowConfig {
  workflow_id?: string;
  workflow_version_id?: string;
  name?: string;
  workflow_label_name?: string;
  workflow_version_number?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  input_variables?: Record<string, any>;
  verbose?: boolean;
  return_all_outputs?: boolean;
}

interface LoopConfigProps {
  loopType: LoopType;
  promptConfig?: PromptTemplateConfiguration;
  onPromptConfigChange: (config: PromptTemplateConfiguration) => void;
  workflowConfig?: WorkflowConfig;
  onWorkflowConfigChange: (config: WorkflowConfig) => void;
  readonly?: boolean;
  showVerboseMode?: boolean;
}

const LoopConfig = ({
  loopType,
  promptConfig,
  onPromptConfigChange,
  workflowConfig,
  onWorkflowConfigChange,
  readonly,
  showVerboseMode = true,
}: LoopConfigProps) => {
  switch (loopType) {
    case LoopType.PROMPT:
      return (
        <PromptLoopConfig
          promptName={promptConfig?.template?.name}
          promptId={promptConfig?.template?.id}
          versionNumber={promptConfig?.template?.version_number}
          label={promptConfig?.template?.label}
          verbose={promptConfig?.verbose}
          promptTemplateVariableMappings={promptConfig?.prompt_template_variable_mappings}
          inlineTemplate={promptConfig?.inline_template}
          onConfigChange={
            onPromptConfigChange as (config: LoopConfiguration["prompt_config"]) => void
          }
          readonly={readonly}
          showVerboseMode={showVerboseMode}
        />
      );
    case LoopType.WORKFLOW:
      return (
        <WorkflowLoopConfig
          workflowName={workflowConfig?.name}
          workflowId={workflowConfig?.workflow_id}
          versionNumber={workflowConfig?.workflow_version_number}
          labelName={workflowConfig?.workflow_label_name}
          verbose={workflowConfig?.verbose}
          returnAllOutputs={workflowConfig?.return_all_outputs}
          onConfigChange={
            onWorkflowConfigChange as (config: LoopConfiguration["workflow_config"]) => void
          }
          readonly={readonly}
          showVerboseMode={showVerboseMode}
        />
      );
    default:
      return null;
  }
};

export default LoopConfig;
